import { render } from "./MacroeconomicIndicators.vue?vue&type=template&id=3b984d7e"
import script from "./MacroeconomicIndicators.vue?vue&type=script&lang=js"
export * from "./MacroeconomicIndicators.vue?vue&type=script&lang=js"

import "./MacroeconomicIndicators.vue?vue&type=style&index=0&id=3b984d7e&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__